// @ts-nocheck
import cx from 'js/lib/helpers/cx'

import styles from './NavigationMenu.module.css'

const NavigationMenu = ({ as, className, style, ...rest }) => {
    const Tag = as || 'div'

    return (
        <Tag
            className={cx(styles.wrapper, className)}
            style={style}
            {...rest}
        />
    )
}

export default NavigationMenu
